import React from 'react';

function Footer() {
    return (
        <footer>
            <div className="footerText wrapper">
                <p>Created and Designed by &copy; Norre Daroy 2019 </p> 
                <p className="credits">Data provided by PokeAPI</p> 
            </div>
	    </footer>);
}

export default Footer;